/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const SupplementalFormType = {
    Static: 'RSA_STATIC',
    StaticShort: 'RSA_STATIC_SHORT',
    StaticV202401: 'RSA_STATIC_V202401'
} as const;
export type SupplementalFormType = typeof SupplementalFormType[keyof typeof SupplementalFormType];


export function SupplementalFormTypeFromJSON(json: any): SupplementalFormType {
    return SupplementalFormTypeFromJSONTyped(json, false);
}

export function SupplementalFormTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupplementalFormType {
    return json as SupplementalFormType;
}

export function SupplementalFormTypeToJSON(value?: SupplementalFormType | null): any {
    return value as any;
}

